import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReclamationInfosValidationDemandeEnlevement } from 'utils/fetchers';
import PrevenirClientRepriseMarchandiseDialogContent from './PrevenirClientRepriseMarchandiseDialogContent';
import withLoader from 'components/Shared/withLoader';

const PrevenirClientRepriseMarchandiseDialogContentWithLoader = withLoader(PrevenirClientRepriseMarchandiseDialogContent);

class PrevenirClientRepriseMarchandiseDialogContentContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    async componentDidMount() {
        const { reclamationId } = this.props;

        var result = await this.props.fetchReclamationInfosValidationDemandeEnlevement(reclamationId);

        this.setState({ ...result, isLoading: false });
    }
    
    render() {
        const { onChange, action } = this.props;
        const { isLoading, contenuMail, categorieCode, qualificationCode } = this.state;

        return (
            <PrevenirClientRepriseMarchandiseDialogContentWithLoader
                isLoading={isLoading}
                contenuMail={contenuMail}
                onChange={onChange}
                action={action}
                categorieCode={categorieCode}
                qualificationCode={qualificationCode}
            />
        );
    }
}

PrevenirClientRepriseMarchandiseDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapDispatchToProps = {
    fetchReclamationInfosValidationDemandeEnlevement
};

export default connect(null, mapDispatchToProps)(PrevenirClientRepriseMarchandiseDialogContentContainer);